import type { ExternalSlabStyle } from './externalSlabCatalogue';
import type { GlazingSlot } from './glazingSlots';
import { EMPTY_HARDWARE_GUIDES, type HardwareGuides } from './hardwareGuides';
import type { PreparedExternalSlabArtwork } from './prepareExternalSlabArtwork';
import {
  SLAB_ARTWORK_REFERENCE_HEIGHT,
  SLAB_ARTWORK_REFERENCE_WIDTH,
} from './prepareExternalSlabArtwork';

export interface DoorStyleDefinition {
  id: string;
  name: string;
  asset: string;
  referenceWidth: number;
  referenceHeight: number;
  glazingSlots: GlazingSlot[];
  hardwareGuides: HardwareGuides;
}

export function doorStyleDefinitionFrom(
  style: ExternalSlabStyle,
  artwork: PreparedExternalSlabArtwork | null
): DoorStyleDefinition {
  return {
    id: style.id,
    name: style.name,
    asset: style.publicPath,
    referenceWidth: artwork?.referenceWidth ?? SLAB_ARTWORK_REFERENCE_WIDTH,
    referenceHeight: artwork?.referenceHeight ?? SLAB_ARTWORK_REFERENCE_HEIGHT,
    glazingSlots: artwork?.glazingSlots ?? [],
    hardwareGuides: artwork?.hardwareGuides ?? EMPTY_HARDWARE_GUIDES,
  };
}
